import {
  DefaultsApi,
  useAPIQuery,
  IdentityMelcoAnalyticsModelsWidgetListItem,
} from "melco-shared-logic";
import { useTable } from "../table/useTable";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useGetAllWizards = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<IdentityMelcoAnalyticsModelsWidgetListItem>({
    //  MelcoCoreModelsSharedGenericList1MelcoCoreModelsProductListItem
    pageSizeOptions: [10, 20],
    pageSize: 20,
  });

  const query = useAPIQuery(
    DefaultsApi,
    [
      "getAllActiveUsersWizards",
      currentPage,
      pageSize,
      filters,
      sortBy(),
      searchQuery,
    ],
    async (api) => {
      let response;
      // if(filters?.ActiveUsersWizards) {

      response = await api.defaultsGetWizards();
      // }

      setTotal(response?.total ? response?.total : 0);

      return response?.list ? response?.list : [];
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    errorComponent,
    searchQueryChange,
    ...query,
  };
};
